export default {
  accessResources: "Access startup resources to support you with your journey.",
  resources: "Resources",
  modal: {
    visitResource: "Visit resource",
  },
};
